import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setShowBanner(true);
    } else {
      const consentData = JSON.parse(consent);
      if (consentData.analytics) {
        enableAnalytics();
      }
    }
  }, []);

  const enableAnalytics = () => {
    // Enable Google Analytics
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'granted'
      });
    }
  };

  const disableAnalytics = () => {
    // Disable Google Analytics
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'denied'
      });
    }
  };

  const handleAcceptAll = () => {
    const consentData = {
      necessary: true,
      analytics: true,
      timestamp: new Date().toISOString()
    };
    
    localStorage.setItem('cookie-consent', JSON.stringify(consentData));
    setShowBanner(false);
    enableAnalytics();
    
    toast.success('Súhlas s cookies bol uložený', {
      duration: 3000,
      position: 'bottom-right',
    });
  };

  const handleAcceptNecessary = () => {
    const consentData = {
      necessary: true,
      analytics: false,
      timestamp: new Date().toISOString()
    };
    
    localStorage.setItem('cookie-consent', JSON.stringify(consentData));
    setShowBanner(false);
    disableAnalytics();
    
    toast.success('Používame len nevyhnutné cookies', {
      duration: 3000,
      position: 'bottom-right',
    });
  };


  if (!showBanner) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t-2 border-blue-500 shadow-2xl">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
          {/* Content */}
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              🍪 Používame cookies
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Táto stránka používa cookies na zlepšenie vašich skúseností a analýzu návštevnosti. 
              Nevyhnutné cookies sú vždy aktívne. Môžete si vybrať, či povolíte analytické cookies.
            </p>
            <div className="mt-3 text-xs text-gray-500">
              <a 
                href="https://www.minv.sk/?ochrana-osobnych-udajov-gdpr" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 underline"
              >
                Ochrana údajov
              </a>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
            <button
              onClick={handleAcceptNecessary}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-200"
            >
              Len nevyhnutné
            </button>
            <button
              onClick={handleAcceptAll}
              className="px-6 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl"
            >
              Prijať všetky
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
